module.exports = __webpack_public_path__ + "static/img/7433_phase_function_Paper_PointsHejduk_Prediction.ec9d585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7433_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Kkkc
// module chunks = 0